module.exports = __webpack_public_path__ + "fonts/pinterest-dark-2.3e58fc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinterest-dark-2.svg
// module id = 876
// module chunks = 0